import * as _ from 'underscore';

export class PopupServiceCancel {
    static cancel = 'cancel';
    static closed = 'closed';
    static backdropClick = 'backdrop click';
    static escapeKeyPress = 'escape key press';
    static readonly safeErrors = [PopupServiceCancel.backdropClick, PopupServiceCancel.cancel, PopupServiceCancel.escapeKeyPress];
    message: string;
    stack: string;
    readonly name: string = 'PopupServiceCancel';

    static isBackdropClick(error: any) {
        return _.isString(error) && error.toLowerCase() === this.backdropClick;
    }
    static isCancelInstance(error: any) {
        return error instanceof PopupServiceCancel && (<PopupServiceCancel>error).message === this.cancel;
    }
    static isClosedInstance(error: any) {
        return error instanceof PopupServiceCancel && (<PopupServiceCancel>error).message === this.closed;
    }
    static isCancelOrBackdropClickInstance(error: any) {
        return this.isCancelInstance(error) || this.isClosedInstance(error) || this.isBackdropClick(error);
    }
    static isCancel(error: any) {
        return _.isString(error) && error.toLowerCase() === this.cancel;
    }

    static isCancelOrBackdropClick(error: any) {
        if (_.isString(error)) {
            return this.safeErrors.indexOf(error.toLowerCase()) > -1;
        }

        return false;
    }

    constructor(msg?: string) {
        this.message = msg ? msg : PopupServiceCancel.cancel;
        this.stack = (new Error()).stack;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/models/popupServiceCancel.ts